import { render, staticRenderFns } from "./OnuAguardando.vue?vue&type=template&id=2a1de478&"
import script from "./OnuAguardando.vue?vue&type=script&lang=js&"
export * from "./OnuAguardando.vue?vue&type=script&lang=js&"
import style0 from "./OnuAguardando.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports